const LOCALPATH = 'test'

let baseURL = ''
if (process.env.NODE_ENV === 'development') {
  baseURL = `/${LOCALPATH}/`
} else if (process.env.BASE_URL === '/wxyhh/unicom/') {
  baseURL = '/wxyhh/'
} else {
  baseURL = ''
}

export default baseURL
